import { useCachedTags, type ModelsWithCachedTags } from "@tellescope/tanstack-query";
import { Circle, Plus } from "lucide-react";
import { Badge, Button, Input } from "@tellescope/ui";
import { useForm } from "@tellescope/forms";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export interface AddTagContentProps {
  currentTags: string[];
  model: ModelsWithCachedTags;
  onTagClick: (tagName: string) => Promise<void> | void;
}

export const AddTagContent = ({ currentTags, model, onTagClick }: AddTagContentProps) => {
  const { t } = useTranslation("tags");
  const { data: suggestedTags } = useCachedTags({ model });
  const [isAddingTag, setIsAddingTag] = useState(false);
  const form = useForm({
    fields: {
      newTagName: {
        type: "text",
        initialValue: "",
      },
    },
    onSubmit: async (fields) => {
      setIsAddingTag(false);
      await onTagClick(fields.newTagName);
    },
    resetOnSubmit: true,
  });

  return (
    <>
      <div className="p-2">
        {suggestedTags.length ? (
          <>
            <div className="text-xs font-medium text-muted-foreground mb-2">{t("Existing Tags")}</div>
            <div className="space-y-1 max-h-32 overflow-y-auto">
              {suggestedTags.map((tag, i) => (
                <div
                  key={`${i}-${tag}`}
                  className="flex items-center justify-between p-1.5 rounded hover:bg-muted cursor-pointer"
                  onClick={() => onTagClick(tag)}
                >
                  <div className="flex items-center gap-2">
                    <Circle
                      className="h-3 w-3"
                      style={{
                        color: "var(--bg-gray-900)",
                        fill: currentTags.includes(tag) ? "var(--bg-gray-900)" : "",
                      }}
                    />
                    <span className="text-sm">{tag}</span>
                  </div>
                  {currentTags.some((appliedTag) => appliedTag === tag) && (
                    <Badge variant="secondary" className="h-4 px-1.5 text-xs">
                      {t("Applied")}
                    </Badge>
                  )}
                </div>
              ))}
            </div>
          </>
        ) : null}
        <div className={suggestedTags.length ? "border-t pt-2 mt-2" : ""}>
          {isAddingTag ? (
            <form {...form.getFormProps()} className="space-y-1">
              <label className="text-sm font-medium">{t("Tag Name")}</label>
              <Input {...form.getFieldProps("newTagName")} placeholder="Enter tag name" className="w-full" autoFocus />
            </form>
          ) : (
            <Button variant="ghost" size="sm" className="w-full justify-start" onClick={() => setIsAddingTag(true)}>
              <Plus className="mr-2 h-3 w-3" />
              {t("Create New Tag")}
            </Button>
          )}
        </div>

        {/* TODO: re-implement once we support colors */}
        {/* <div className="border-t pt-2 mt-2"> */}
        {/*   <Dialog open={isCreateDialogOpen} onOpenChange={setIsCreateDialogOpen}> */}
        {/*     <DialogTrigger asChild> */}
        {/*       <Button variant="ghost" size="sm" className="w-full justify-start"> */}
        {/*         <Plus className="mr-2 h-3 w-3" /> */}
        {/*         Create New Tag */}
        {/*       </Button> */}
        {/*     </DialogTrigger> */}
        {/*     <DialogContent className="sm:max-w-md"> */}
        {/*       <DialogHeader> */}
        {/*         <DialogTitle>Create New Tag</DialogTitle> */}
        {/*       </DialogHeader> */}
        {/*       <div className="space-y-4 pt-4"> */}
        {/*         <div className="space-y-2"> */}
        {/*           <label className="text-sm font-medium">Tag Name</label> */}
        {/*           <Input */}
        {/*             value={newTagName} */}
        {/*             onChange={(e) => setNewTagName(e.target.value)} */}
        {/*             placeholder="Enter tag name" */}
        {/*             className="w-full" */}
        {/*           /> */}
        {/*         </div> */}
        {/**/}
        {/*         <div className="space-y-2"> */}
        {/*           <label className="text-sm font-medium">Color</label> */}
        {/*           <div className="grid grid-cols-4 gap-2"> */}
        {/*             {tagColors.map((color) => ( */}
        {/*               <button */}
        {/*                 key={color.value} */}
        {/*                 type="button" */}
        {/*                 className={`w-8 h-8 rounded-full border-2 ${ */}
        {/*                   selectedColor === color.value ? "border-foreground" : "border-muted" */}
        {/*                 }`} */}
        {/*                 style={{ backgroundColor: color.value }} */}
        {/*                 onClick={() => setSelectedColor(color.value)} */}
        {/*                 title={color.name} */}
        {/*               /> */}
        {/*             ))} */}
        {/*           </div> */}
        {/*           <div className="flex items-center gap-2 mt-2"> */}
        {/*             <div className="w-4 h-4 rounded border" style={{ backgroundColor: selectedColor }} /> */}
        {/*             <span className="text-sm text-muted-foreground"> */}
        {/*               Selected: {tagColors.find((c) => c.value === selectedColor)?.name} */}
        {/*             </span> */}
        {/*           </div> */}
        {/*         </div> */}
        {/**/}
        {/*         <div className="flex justify-end gap-2 pt-4"> */}
        {/*           <Button variant="outline" onClick={() => setIsCreateDialogOpen(false)}> */}
        {/*             Cancel */}
        {/*           </Button> */}
        {/*           <Button onClick={handleCreateTag} disabled={!newTagName.trim()}> */}
        {/*             Create Tag */}
        {/*           </Button> */}
        {/*         </div> */}
        {/*       </div> */}
        {/*     </DialogContent> */}
        {/*   </Dialog> */}
        {/* </div> */}
      </div>
    </>
  );
};
